import React, { useState, useEffect, useCallback } from 'react';

import api from '../../../services/api';

import Input from '../../../components/Input';
import Select from '../../../components/Select';
import Button from '../../../components/Button/custom';

import { useStates } from '../../../hooks/states';

import { GridForm, GridButton } from '../styles';

interface IForm {
  form: any;
  handleCep: any;
  type: string;
}

const Cpf: React.FC<IForm> = ({ form, handleCep, type }) => {
  const [cities, setCities] = useState([]);
  const [state, setState] = useState('');
  const { states } = useStates();

  useEffect(() => {
    if (!state && !form.state) {
      return;
    }

    async function loadCity() {
      const response = await api.get(`tables/cities/${state ? state: form.state}`);

      setCities(response.data);
    }

    loadCity();
  }, [state, form.state]);

  const handleChangeState = useCallback((title) => {
    setState(title);
  }, []);

  return (
    <>
            <GridForm grid={211}>
              <div className="form-group">
                <label>Nome Completo <span>*</span></label>
                <Input name="full_name" />
              </div>
              <div className="form-group">
                <label>Apelido</label>
                <Input name="nickname" />
              </div>
              <div className="form-group">
                <label>Email</label>
                <Input name="email" />
              </div>
            </GridForm>

            <GridForm grid={4}>
              <div className="form-group">
                <label>Data de Nascimento <span>*</span></label>
                <Input name="birth" type="date" />
              </div>
              <div className="form-group">
                <label>Sexo <span>*</span></label>
                <Select name="sex">
                  <option value="">...</option>
                  <option value="MASCULINO" selected={form.sex === 'MASCULINO'}>MASCULINO</option>
                  <option value="FEMENINO" selected={form.sex === 'FEMENINO'}>FEMENINO</option>
                </Select>
              </div>
              <div className="form-group">
                <label>Estado Civil <span>*</span></label>
                <Select name="civil_status">
                  <option value="">...</option>
                  <option value="SOLTEIRO(a)" selected={form.civil_status === 'SOLTEIRO(a)'}>SOLTEIRO (a)</option>
                  <option value="CASADO" selected={form.civil_status === 'CASADO'}>CASADO</option>
                  <option value="DIVORCIADO" selected={form.civil_status === 'DIVORCIADO'}>DIVORCIADO</option>
                </Select>
              </div>
              <div className="form-group">
                <label>Estrangeiro?</label>
                <Select name="exterior">
                <option value="NÃO" selected={form.exterior === 'NÃO'}>NÃO</option>
                  <option value="SIM" selected={form.exterior === 'SIM'}>SIM</option>
                </Select>
              </div>
            </GridForm>

            <GridForm grid={2}>
              <div className="form-group">
                <label>Nome do Pai</label>
                <Input name="name_dad" />
              </div>
              <div className="form-group">
                <label>Nome da Mãe <span>*</span></label>
                <Input name="name_mother" />
              </div>
            </GridForm>

            <GridForm grid={3}>
              <div className="form-group">
                <label>Nacionalidade</label>
                <Input name="nationality" defaultValue="Brasileiro" />
              </div>
              <div className="form-group">
                <label>Naturalidade</label>
                <Input name="naturalness" />
              </div>
              <div className="form-group">
                <label>CPF <span>*</span></label>
                <Input name="fiscal_number" mask="cpf" id="cpf" />
              </div>
            </GridForm>

            <GridForm grid={4}>
              <div className="form-group">
                <label>R.G Número <span>*</span></label>
                <Input name="identity_id" />
              </div>
              <div className="form-group">
                <label>R.G Emissão</label>
                <Input type="date" name="identity_emission" />
              </div>
              <div className="form-group">
                <label>R.G Estado</label>
                <Select name="identity_state">
                  <option value="">...</option>
                  {states.map((state: any) => {
                    return (
                      <option
                        key={state.sigla}
                        value={String(state.sigla)}
                        selected={String(state.sigla) === form.identity_state}
                      >
                        {state.nome.toUpperCase()}
                      </option>
                    );
                  })}
                </Select>
              </div>
              <div className="form-group">
                <label>R.G Orgão Expedidor</label>
                <Input type="date" name="identity_organ" />
              </div>
            </GridForm>

            <GridForm grid={5}>
              <div className="form-group">
                <label>Pasaport Número</label>
                <Input name="passport_number" />
              </div>
              <div className="form-group">
                <label>Pasaport Emissão</label>
                <Input type="date" name="passport_emission" />
              </div>
              <div className="form-group">
                <label>Pasaport País</label>
                <Input name="passport_nation" />
              </div>
              <div className="form-group">
                <label>Telefone</label>
                <Input name="phone" mask="phone" id="phone" />
              </div>
              <div className="form-group">
                <label>Celular / Whatsapp <span>*</span></label>
                <Input name="phone_whatsapp" mask="celular" id="celular" />
              </div>
            </GridForm>

            <GridForm grid={1211}>
              <div className="form-group">
                <label>Cep <span>*</span></label>
                <Input name="zip_code" mask="cep" id="cep" onBlur={(event) => handleCep(event.target.value)} />
              </div>
              <div className="form-group">
                <label>Endereço <span>*</span></label>
                <Input name="address" />
              </div>
              <div className="form-group">
                <label>Número <span>*</span></label>
                <Input name="address_number" />
              </div>
              <div className="form-group">
                <label>Complemento</label>
                <Input name="address_complement" />
              </div>
            </GridForm>

            <GridForm grid={3}>
              <div className="form-group">
                <label>Bairro <span>*</span></label>
                <Input name="neighborhood" />
              </div>
              <div className="form-group">
              <label>Estado <span>*</span></label>
                <Select name="state" onChange={(event) => handleChangeState(event.target.value)}>
                  <option value="">...</option>
                  {states.map((state: any) => {
                    return (
                      <option
                        key={state.sigla}
                        value={String(state.sigla)}
                        selected={String(state.sigla) === form.state}
                      >
                        {state.nome.toUpperCase()}
                      </option>
                    );
                  })}
                </Select>
              </div>
              <div className="form-group">
                <label>Cidade <span>*</span></label>
                <Select name="city">
                    <option value="">...</option>
                    {cities.map((city: any) => {
                      const cityName = city.name.toUpperCase();
                      return (
                        <option
                          key={city.id}
                          value={cityName}
                          selected={cityName === form.city}
                        >
                          {city.name.toUpperCase()}
                        </option>
                      );
                    })}
                </Select>
              </div>
            </GridForm>

            <GridButton>
              <Button type="submit" color="default" size="large">
                {type}
              </Button>

              {type === 'ATUALIZAR' && (
                <Button color="danger" size="large">Excluir Cadastro</Button>
              )}
            </GridButton>
     </>
  );
};

export default Cpf;
